// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cartridge":"_3L2XC","gallery":"_2GiAw","wrapper":"_2ToZ2","imageSlider":"_3WtZC"};